/*
    Add here your own custom javascript
*/

// Fix for the RTL language in the demo
document.querySelectorAll('[href="/ar"]').forEach(link => {
    link.setAttribute('target', '_blank')
})

// EcomGraduates - Affiliate tracking code
function addRefParamToUrlsAndSetCookie () {
    const urlParams = new URLSearchParams(window.location.search)
    let refParam = urlParams.get('ref')

    if (!refParam) {
        // Check if the "ref" cookie exists
        const cookies = document.cookie.split(';')
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim()
            if (cookie.startsWith('ref=')) {
                refParam = cookie.substring(4)

                urlParams.set('ref', refParam)
                break
            }
        }
    }

    if (refParam) {
    // Set the "ref" cookie with the "ref" parameter value
        document.cookie = `ref=${refParam}; expires=${new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)}; path=/`

        // Update the URLs on the page with the "ref" parameter value
        const links = document.getElementsByTagName('a')
        for (let i = 0; i < links.length; i++) {
            const link = links[i]
            const url = new URL(link.href)
            if (url.hostname === 'ecomgraduates.com') {
                if (url.search) {
                    url.search += `&ref=${refParam}`
                } else {
                    url.search = `?ref=${refParam}`
                }
                link.href = url.href
            }
        }
    }
}
// addRefParamToUrlsAndSetCookie()


// Auto-expand Shipping Policy (2nd accordion item) on product pages
document.addEventListener('DOMContentLoaded', function() {
    if (!document.body.classList.contains('template-product')) return;
    var items = document.querySelectorAll('.product-block-accordion .accordion-item');
    if (items.length >= 2) {
        var btn = items[1].querySelector('.accordion-button');
        var collapse = items[1].querySelector('.accordion-collapse');
        if (btn) {
            btn.classList.remove('collapsed');
            btn.setAttribute('aria-expanded', 'true');
        }
        if (collapse) {
            if (window.bootstrap) {
                bootstrap.Collapse.getOrCreateInstance(collapse, { toggle: false }).show();
            } else {
                collapse.classList.add('show');
            }
        }
    }
});
document.addEventListener('DOMContentLoaded', function() {
  if (!window.location.pathname.includes('/products/')) return;
  setTimeout(function() {
    var subCard = document.getElementById('mj-card-subscription');
    var atcWrap = document.querySelector('.product-buy-buttons');
    if (!subCard || !atcWrap) return;
    atcWrap.insertAdjacentHTML('afterend', '<p class="mj-sub-label">Or subscribe &amp; save monthly</p>');
    atcWrap.parentNode.insertBefore(subCard, atcWrap.nextSibling.nextSibling);
  }, 150);
});
document.addEventListener('DOMContentLoaded', function() {
  if (!window.location.pathname.includes('/products/')) return;
  var wrap = document.querySelector('.mjgra-wrap');
  if (!wrap) return;
  wrap.outerHTML = '<div class="mj-trust-row"><span class="mj-trust-badge"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg> Free Shipping</span><span class="mj-trust-badge"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-3.5"/></svg> 30-Day Returns</span></div>';
});